<template>
  <main>
    <div class="info" v-for="item in myCar" :key="item.index" :class="colorClass[item.carCategory]">
      <div>
        <van-icon name="cross" @click="del(item.id)"/>
        
        <h3>{{item.carNo}}</h3>        
        <p>
          <i>车牌类型: {{textClass[item.carCategory]}}</i>
          <i>{{item.carType}}</i>
        </p>
      </div>
    </div>
    <button class="btn btn-green" @click="link('/addcar')">＋添加车辆</button>
  </main>
</template>

<script>
import API from "../api/index"
import { Dialog, Toast } from 'vant'
import { StringUtil, Cookies } from '../util/index'



    export default {
        inject:['reload'],
        name: "mycar",
                
        data () {
          return {
            myCar: [],
            colorClass:["blue","green","yellow"],
            textClass:["蓝牌","新能源","黄牌"],
          }
        },

        mounted() {
          var _this=this;
          this.$http({
          method:'get',
          params: {
             uId:Cookies.get("uId"),
          },
          url:API.loadMyCar_url
              }).then(function(resp){
                  console.log(resp.data);
                   _this.myCar=resp.data.data;
                }).catch(resp => {
                  console.log('请求失败：'+resp.status+','+resp.statusText);
          });
        },

        methods: {
          

            link(url) {
              const self = this;
              if(Cookies.get("phoneNum") ) {
                this.$router.push(url)
              } else {
                Toast('请先绑定手机号')
                setTimeout(function(){ 
                  self.$router.push({ path: "/phone"});
                 }, 3000);
              }
                
            },


            del(id){
                var _this=this;
                this.$http({
                method:'get',
                params:{
                id:id
                },
                url: API.delCar_url
                }).then(function(resp){
                        Toast.success('删除成功');
                        _this.reload();
                        // _this.myCar=resp.data.data;
                      }).catch(resp => {
                        Toast.fail('删除失败');
                });

            },
    
    }
  }
</script>

<style scoped>
  .info {
    margin: 30px 70px;
  }

  .info div {
    padding: 30px;
    box-shadow: 0 0 10px #ccc;
    border-radius: 10px;
  }

  .info.blue {
    background: #498CE7;
    color: #fff;
  }

  .info.green {
    background: #15B65D;
    color: #fff;
  }

  .info.yellow {
    background: #FFCC00;
    color: #333333;  
  }

  .info div + div {
    margin-top: 30px;
    background: #409eff;
  }

  .info div h3 {
    font-size: 32px;
    text-align: center;
  }

  .info div p {
    display: flex;
    justify-content: space-between;
    font-size: 26px;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/mycar.vue